import axios from "axios";

const API = axios.create({
  baseURL: "https://bizoraadmin.aajcodershub.com",
});

// Request interceptor to add auth token if exists
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth API functions
export const login = async (username, password) => {
  try {
    const response = await API.post("/users/login", { username, password });
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Login failed" };
  }
};

export const register = async (userData) => {
  try {
    const response = await API.post("/users/register", userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Registration failed" };
  }
};

export const getReferralSponsor = async (code) => {
  try {
    const response = await API.get(`/users/sponsor/${code}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Invalid referral link" };
  }
};

export const getPlansList = async () => {
  try {
    const response = await API.get("/plans/list");
    console.log('abc response', response.data.data);
    return response.data.data;
    
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch plans" };
  }
};

export const buyUserPlan = async (userId, planId, paymentMethod) => {
  try {
    const response = await API.post("/user-plans/buy", { userId, planId, paymentMethod });
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Purchase failed" };
  }
};

// Team API functions
export const getTeamSummary = async (userId) => {
  try {
    const response = await API.get(`/team/summary/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch team summary" };
  }
};

export const getTeamLevels = async (userId, level) => {
  try {
    const response = await API.get(`/team/levels/${userId}/${level}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch level team" };
  }
};

export const getTeamTree = async (userId, depth = 5) => {
  try {
    const response = await API.get(`/team/tree/${userId}?depth=${depth}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch team tree" };
  }
};

export const getDirectReferrals = async (userId) => {
  try {
    const response = await API.get(`/team/direct/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch direct referrals" };
  }
};

export const searchTeam = async (userId, keyword) => {
  try {
    const response = await API.get(`/team/search/${userId}?keyword=${keyword}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Team search failed" };
  }
};

// Finance API functions
export const getTransactionHistory = async (userId, params = {}) => {
  try {
    const response = await API.get(`/transactions/history/${userId}`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch transactions" };
  }
};

export const createDeposit = async (data) => {
  try {
    const response = await API.post("/deposit/create", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Deposit request failed" };
  }
};

export const getDepositHistory = async (userId) => {
  try {
    const response = await API.get(`/deposit/history/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch deposit history" };
  }
};

export const getWithdrawMethods = async () => {
  try {
    const response = await API.get("/withdraw/methods");
    console.log('abc methodsonresponse', response.data.methods);
    return response.data.methods;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch withdraw methods" };
  }
};

export const createWithdrawRequest = async (data) => {
  try {
    const response = await API.post("/withdraw/request", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Withdrawal request failed" };
  }
};

export const submitCryptoDeposit = async (data) => {
  try {
    const response = await API.post("/deposit/crypto-submit", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Transaction submission failed" };
  }
};

export const getWithdrawHistory = async (userId) => {
  try {
    const response = await API.get(`/withdraw/history/${userId}`);
    console.log('abc wallet', response);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch withdraw history" };
  }
};

// Notification API functions
export const getUserNotifications = async (userId) => {
  try {
    const response = await API.get(`/notifications/user/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch notifications" };
  }
};

export const getUnreadNotificationCount = async (userId) => {
  try {
    const response = await API.get(`/notifications/unread-count/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to fetch unread count" };
  }
};

export const markNotificationAsRead = async (notificationId, userId) => {
  try {
    const response = await API.post(`/notifications/read/${notificationId}`, { userId });
    return response.data;
  } catch (error) {
    throw error.response?.data || { status: false, message: "Failed to mark as read" };
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export default API;